// 2018 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-25)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2018-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2018-masterwork",
//     name: "2018 Topps Star Wars Masterwork",
//     shortName: "Masterwork 2018",
//     year: 2018,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2018",
//     totalCards: 508,
//     description: "Topps 2018 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2018-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "Anakin Skywalker" },
        { n: "2", name: "Padmé Amidala" },
        { n: "3", name: "Mace Windu" },
        { n: "4", name: "Qui-Gon Jinn" },
        { n: "5", name: "Obi-Wan Kenobi" },
        { n: "6", name: "Darth Maul" },
        { n: "7", name: "Count Dooku" },
        { n: "8", name: "Jango Fett" },
        { n: "9", name: "Yoda" },
        { n: "10", name: "Aayla Secura" },
        { n: "11", name: "Saesee Tiin" },
        { n: "12", name: "Darth Sidious" },
        { n: "13", name: "General Grievous" },
        { n: "14", name: "Tion Medon" },
        { n: "15", name: "Clone Trooper" },
        { n: "16", name: "Boba Fett" },
        { n: "17", name: "Jabba the Hutt" },
        { n: "18", name: "Admiral Ozzel" },
        { n: "19", name: "Scout Trooper" },
        { n: "20", name: "Wicket W. Warrick" },
        { n: "21", name: "Imperial Navy Commander" },
        { n: "22", name: "AT-AT Driver" },
        { n: "23", name: "General Madine" },
        { n: "24", name: "Orrimaarko" },
        { n: "25", name: "Imperial Snowtrooper" },
        { n: "26", name: "Hoth Rebel Trooper" },
        { n: "27", name: "Teebo" },
        { n: "28", name: "Ugnaughts" },
        { n: "29", name: "Tauntaun" },
        { n: "30", name: "Imperial Probe Droid" },
        { n: "31", name: "Captain Needa" },
        { n: "32", name: "Imperial Sandtrooper" },
        { n: "33", name: "Emperor Palpatine" },
        { n: "34", name: "Lando Calrissian" },
        { n: "35", name: "Ezra Bridger" },
        { n: "36", name: "Kanan Jarrus" },
        { n: "37", name: "Hera Syndulla" },
        { n: "38", name: "Sabine Wren" },
        { n: "39", name: "Zeb Orrelios" },
        { n: "40", name: "Chopper" },
        { n: "41", name: "Grand Moff Tarkin" },
        { n: "42", name: "Grand Admiral Thrawn" },
        { n: "43", name: "Governor Arihnda Pryce" },
        { n: "44", name: "Jyn Erso" },
        { n: "45", name: "Captain Cassian Andor" },
        { n: "46", name: "Baze Malbus" },
        { n: "47", name: "Chirrut Îmwe" },
        { n: "48", name: "Bodhi Rook" },
        { n: "49", name: "Pao" },
        { n: "50", name: "Bistan" },
        { n: "51", name: "K-2SO" },
        { n: "52", name: "Saw Gerrera" },
        { n: "53", name: "Mon Mothma" },
        { n: "54", name: "Ponda Baba" },
        { n: "55", name: "Galen Erso" },
        { n: "56", name: "Tivik" },
        { n: "57", name: "Moroff" },
        { n: "58", name: "Imperial Tank Driver" },
        { n: "59", name: "Darth Vader" },
        { n: "60", name: "Private Kappehl" },
        { n: "61", name: "Private Calfor" },
        { n: "62", name: "Corporal Maddel" },
        { n: "63", name: "Teedo" },
        { n: "64", name: "Han Solo" },
        { n: "65", name: "Snap Wexley" },
        { n: "66", name: "Jess \"Testor\" Pava" },
        { n: "67", name: "Ello Asty" },
        { n: "68", name: "Colonel Datoo" },
        { n: "69", name: "Maz Kanata" },
        { n: "70", name: "Rathtar" },
        { n: "71", name: "Rey" },
        { n: "72", name: "Luke Skywalker" },
        { n: "73", name: "Kylo Ren" },
        { n: "74", name: "Finn" },
        { n: "75", name: "Poe Dameron" },
        { n: "76", name: "General Leia Organa" },
        { n: "77", name: "Chewbacca" },
        { n: "78", name: "First Order Stormtrooper" },
        { n: "79", name: "Porg" },
        { n: "80", name: "BB-8" },
        { n: "81", name: "Admiral Ackbar" },
        { n: "82", name: "Rose Tico" },
        { n: "83", name: "Paige Tico" },
        { n: "84", name: "Supreme Leader Snoke" },
        { n: "85", name: "Kaydel Ko Connix" },
        { n: "86", name: "DJ" },
        { n: "87", name: "Tallissan \"Tallie\" Lintra" },
        { n: "88", name: "C'ai Threnalli" },
        { n: "89", name: "General Hux" },
        { n: "90", name: "Captain Peavey" },
        { n: "91", name: "Praetorian Guard" },
        { n: "92", name: "Commander D'Acy" },
        { n: "93", name: "Master Codebreaker" },
        { n: "94", name: "Temiri Blagg" },
        { n: "95", name: "Colonel Ansiv Garmuth" },
        { n: "96", name: "Captain Phasma" },
        { n: "97", name: "Executioner Stormtrooper" },
        { n: "98", name: "Vulptex" },
        { n: "99", name: "General Ematt" },
        { n: "100", name: "Vice Admiral Amilyn Holdo" },
    ],
  },
  {
    id: "base-card-short-prints",
    type: "base",
    title: "BASE CARD SHORT PRINTS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "101", name: "Luke Skywalker" },
        { n: "102", name: "Princess Leia Organa" },
        { n: "103", name: "Rey" },
        { n: "104", name: "Finn" },
        { n: "105", name: "Obi-Wan Kenobi" },
        { n: "106", name: "Anakin Skywalker" },
        { n: "107", name: "Yoda" },
        { n: "108", name: "Darth Vader" },
        { n: "109", name: "Darth Maul" },
        { n: "110", name: "Boba Fett" },
        { n: "111", name: "Han Solo" },
        { n: "112", name: "Chewbacca" },
        { n: "113", name: "Lando Calrissian" },
        { n: "114", name: "Saw Gerrera" },
        { n: "115", name: "Jyn Erso" },
        { n: "116", name: "Captain Cassian Andor" },
        { n: "117", name: "Director Krennic" },
        { n: "118", name: "Poe Dameron" },
        { n: "119", name: "Kylo Ren" },
        { n: "120", name: "First Order Stormtrooper" },
        { n: "121", name: "Ahsoka Tano" },
        { n: "122", name: "Emperor Palpatine" },
        { n: "123", name: "Wedge Antilles" },
        { n: "124", name: "Bo-Katan Kryze" },
        { n: "125", name: "The Grand Inquisitor" },
    ],
  },
  {
    id: "history-of-the-jedi",
    type: "insert",
    title: "HISTORY OF THE JEDI",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "HJ-1", name: "Yoda" },
        { n: "HJ-2", name: "Mace Windu" },
        { n: "HJ-3", name: "Count Dooku" },
        { n: "HJ-4", name: "Qui-Gon Jinn" },
        { n: "HJ-5", name: "Obi-Wan Kenobi" },
        { n: "HJ-6", name: "Anakin Skywalker" },
        { n: "HJ-7", name: "Kanan Jarrus" },
        { n: "HJ-8", name: "Ezra Bridger" },
        { n: "HJ-9", name: "Luke Skywalker" },
        { n: "HJ-10", name: "Rey" },
    ],
  },
  {
    id: "source-material-fabric-swatch-cards",
    type: "insert",
    title: "SOURCE MATERIAL FABRIC SWATCH CARDS",
    parallels: [
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "JR-GH", name: "General Hux Jacket Lining" },
        { n: "JR-LP", name: "Luke Skywalker Pants" },
        { n: "JR-LT", name: "Luke Skywalker Tunic" },
        { n: "JR-PD", name: "Poe Dameron Jacket Lining" },
        { n: "JR-RG", name: "Poe Dameron Shirt" },
        { n: "JR-RS", name: "Jyn Erso Poncho" },
        { n: "JR-RT", name: "Rey Desert Tunic Sleeves" },
        { n: "JRC-RT", name: "Rose Tico Ground Crew Flightsuit Lining" },
    ],
  },
  {
    id: "vehicle-patch-cards",
    type: "insert",
    title: "VEHICLE PATCH CARDS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MP-BHF", name: "Slave I - Boba Fett" },
        { n: "MP-BHL", name: "Slave I - 4-LOM" },
        { n: "MP-BHZ", name: "Slave I - Zuckuss" },
        { n: "MP-GEA", name: "Chimaera - Grand Admiral Thrawn" },
        { n: "MP-GED", name: "Krennic's Shuttle - Director Krennic" },
        { n: "MP-GEE", name: "Star Destroyer - Emperor Palpatine" },
        { n: "MP-GEK", name: "Chimaera - Kassius Konstantine" },
        { n: "MP-GEM", name: "Krennic's Shuttle - Grand Moff Tarkin" },
        { n: "MP-GEP", name: "Chimaera - Governor Arihnda Pryce" },
        { n: "MP-GES", name: "Star Destroyer - Stormtrooper" },
        { n: "MP-GEV", name: "Star Destroyer - Darth Vader" },
        { n: "MP-GRB", name: "Radiant VII - Bail Organa" },
        { n: "MP-GRM", name: "Radiant VII - Mon Mothma" },
        { n: "MP-GRP", name: "Radiant VII - Padmé Amidala" },
        { n: "MP-JOA", name: "Anakin's Fighter - Anakin Skywalker" },
        { n: "MP-JOO", name: "Anakin's Fighter - Obi-Wan Kenobi" },
        { n: "MP-JOQ", name: "Anakin's Fighter - Qui-Gon Jinn" },
        { n: "MP-JOY", name: "Anakin's Fighter - Yoda" },
        { n: "MP-PSA", name: "The Ghost - Ahsoka Tano" },
        { n: "MP-PSE", name: "The Ghost - Ezra Bridger" },
        { n: "MP-PSH", name: "The Ghost - Hera Syndulla" },
        { n: "MP-PSK", name: "The Ghost - Kanan Jarrus" },
        { n: "MP-PSZ", name: "The Ghost - Zeb Orrelios" },
        { n: "MP-RAA", name: "U-Wing - Captain Cassian Andor" },
        { n: "MP-RAB", name: "U-Wing - Bodhi Rook" },
        { n: "MP-RAC", name: "Y-Wing - C-3PO" },
        { n: "MP-RAH", name: "Y-Wing - Han Solo" },
        { n: "MP-RAI", name: "U-Wing - Chirrut Îmwe" },
        { n: "MP-RAJ", name: "U-Wing - Jyn Erso" },
        { n: "MP-RAK", name: "U-Wing - K-2SO" },
        { n: "MP-RAM", name: "U-Wing - Baze Malbus" },
        { n: "MP-RAP", name: "Y-Wing - Princess Leia Organa" },
        { n: "MP-RAR", name: "Y-Wing - R2-D2" },
        { n: "MP-RAS", name: "Y-Wing - Luke Skywalker" },
        { n: "MP-RMH", name: "The Millennium Falcon - Han Solo" },
        { n: "MP-RML", name: "The Millennium Falcon - Lando Calrissian" },
        { n: "MP-RMN", name: "The Millennium Falcon - Nien Nunb" },
        { n: "MP-RMP", name: "The Millennium Falcon - Princess Leia Organa" },
        { n: "MP-RMS", name: "The Millennium Falcon - Luke Skywalker" },
        { n: "MP-SCD", name: "Solar Sailer - Count Dooku" },
        { n: "MP-SDS", name: "Solar Sailer - Darth Sidious" },
        { n: "MP-SGG", name: "Solar Sailer - General Grievous" },
        { n: "MP-TRF", name: "Black One - Finn" },
        { n: "MP-TRH", name: "Black One - Vice Admiral Amilyn Holdo" },
        { n: "MP-TRL", name: "Black One - General Leia Organa" },
        { n: "MP-TRP", name: "Black One - Poe Dameron" },
        { n: "MP-TRR", name: "Black One - Rey" },
    ],
  },
  // Signer sub-sets: card numbers are the printed card-back codes (nslists.com/swmast18.htm,
  // spot-checked against 15 eBay/slab specimens incl. A-JAT, A-GO, A-RN and Paul Kasey's A-CS).
  // The official Topps PDF lists signers without numbers. A-SLJ (Samuel L. Jackson) is
  // CK-assigned: no source shows a printed code for his card.
  {
    id: "animated-signers",
    type: "auto",
    title: "ANIMATED SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-AE", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "A-JAT", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "A-ML", name: "Matt Lanter as Anakin Skywalker" },
        { n: "A-SWT", name: "Sam Witwer as Darth Maul" },
        { n: "A-JSP", name: "Jason Spisak as Lux Bonteri" },
        { n: "A-AK", name: "Andrew Kishino as Saw Gerrera" },
        { n: "A-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "A-BS", name: "Brent Spiner as Gall Trayvis" },
    ],
  },
  {
    id: "classic-signers",
    type: "auto",
    title: "CLASSIC SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "A-HF", name: "Harrison Ford as Han Solo" },
        { n: "A-BW", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "A-JB", name: "Jeremy Bulloch as Boba Fett" },
        { n: "A-CR", name: "Clive Revill as Voice of The Emperor" },
        { n: "A-DL", name: "Denis Lawson as Wedge Antilles" },
        { n: "A-CB", name: "Caroline Blakiston as Mon Mothma" },
        { n: "A-HW", name: "Howie Weed as The Wampa" },
        { n: "A-DB", name: "David Barclay as Puppeteer for Yoda" },
        { n: "A-SW", name: "Simon Williamson as Puppeteer for Max Rebo" },
    ],
  },
  {
    id: "the-force-awakens-signers",
    type: "auto",
    title: "THE FORCE AWAKENS SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-KL", name: "Ken Leung as Admiral Statura" },
        { n: "A-CC", name: "Cavin Cornwall as Sidon Ithano" },
        { n: "A-NC", name: "Nathalie Cuzner as PZ-4CO" },
    ],
  },
  {
    id: "prequel-era-signers",
    type: "auto",
    title: "PREQUEL ERA SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-SLJ", name: "Samuel L. Jackson as Mace Windu" },
        { n: "A-IM", name: "Ian McDiarmid as Supreme Chancellor Palpatine" },
        { n: "A-HC", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "A-RP", name: "Ray Park as Darth Maul" },
        { n: "A-MW", name: "Matthew Wood as General Grievous" },
    ],
  },
  {
    id: "rogue-one-signers",
    type: "auto",
    title: "ROGUE ONE SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-MM", name: "Mads Mikkelsen as Galen Erso" },
        { n: "A-BM", name: "Ben Mendelsohn as Director Krennic" },
        { n: "A-FW", name: "Forest Whitaker as Saw Gerrera" },
        { n: "A-RA", name: "Riz Ahmed as Bodhi Rook" },
        { n: "A-AT", name: "Alan Tudyk as K-2SO" },
        { n: "A-BDN", name: "Ben Daniels as General Merrick" },
        { n: "A-GO", name: "Genevieve O'Reilly as Mon Mothma" },
        { n: "A-GH", name: "Guy Henry as Voice of Grand Moff Tarkin" },
        { n: "A-DC", name: "Dave Chapman as Puppeteer for SE-2 Worker Droid" },
        { n: "A-RN", name: "Robert Nairne as Kullbee Sperado" },
        { n: "A-TW", name: "Tom Wilton as Ponda Baba" },
        { n: "A-AP", name: "Alistair Petrie as General Draven" },
        { n: "A-DP", name: "Duncan Pow as Sergeant Melshi" },
        { n: "A-DM", name: "Daniel Mays as Tivik" },
        { n: "A-JST", name: "Jordan Stephens as Corporal Tonc" },
    ],
  },
  {
    id: "the-last-jedi-signers",
    type: "auto",
    title: "THE LAST JEDI SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-DR", name: "Daisy Ridley as Rey" },
        { n: "A-ADR", name: "Adam Driver as Kylo Ren" },
        { n: "A-AS", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "A-LD", name: "Laura Dern as Vice Admiral Amilyn Holdo" },
        { n: "A-BH", name: "Brian Herring as Puppeteer for BB-8" },
        { n: "A-JV", name: "Jimmy Vee as R2-D2" },
        { n: "A-CS", name: "Paul Kasey as C'ai Threnalli" },
        { n: "A-CCK", name: "Crystal Clarke as Ensign Pamich Nerro Goode" },
        { n: "A-AJ", name: "Andrew Jack as General Ematt" },
    ],
  },
  {
    id: "powerful-partners",
    type: "insert",
    title: "POWERFUL PARTNERS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "PP-1", name: "Han Solo & Chewbacca" },
        { n: "PP-2", name: "C-3PO & R2-D2" },
        { n: "PP-3", name: "Luke Skywalker & Princess Leia Organa" },
        { n: "PP-4", name: "Darth Vader & Grand Moff Tarkin" },
        { n: "PP-5", name: "Obi-Wan Kenobi & Anakin Skywalker" },
        { n: "PP-6", name: "Jyn Erso & Captain Cassian Andor" },
        { n: "PP-7", name: "Rey & Finn" },
        { n: "PP-8", name: "Finn & Rose Tico" },
    ],
  },
  {
    id: "stamp-cards",
    type: "insert",
    title: "STAMP CARDS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "S-BF", name: "Finn - BB-8!" },
        { n: "S-BP", name: "Poe Dameron - BB-8!" },
        { n: "S-BR", name: "Rey - BB-8!" },
        { n: "S-CC", name: "Chewbacca - Chewbacca!" },
        { n: "S-CH", name: "Han Solo - Chewbacca!" },
        { n: "S-CL", name: "Lando Calrissian - Chewbacca!" },
        { n: "S-CP", name: "Princess Leia Organa - C-3PO and Jabba the Hutt's Palace" },
        { n: "S-CR", name: "R2-D2 - C-3PO and Jabba the Hutt's Palace" },
        { n: "S-CS", name: "Luke Skywalker - C-3PO and Jabba the Hutt's Palace" },
        { n: "S-KC", name: "Captain Cassian Andor - K-2SO on Scarif!" },
        { n: "S-KJ", name: "Jyn Erso - K-2SO on Scarif!" },
        { n: "S-KK", name: "K-2SO - K-2SO on Scarif!" },
        { n: "S-MF", name: "Finn - Maz Kanata's Castle!" },
        { n: "S-MH", name: "Han Solo - Maz Kanata's Castle!" },
        { n: "S-MR", name: "Rey - Maz Kanata's Castle!" },
        { n: "S-PC", name: "Chewbacca - Ahch-To Island Porgs!" },
        { n: "S-PL", name: "Luke Skywalker - Ahch-To Island Porgs!" },
        { n: "S-PR", name: "Rey - Ahch-To Island Porgs!" },
        { n: "S-RA", name: "Anakin Skywalker - R2-D2!" },
        { n: "S-RO", name: "Obi-Wan Kenobi - R2-D2!" },
        { n: "S-RP", name: "Padmé Amidala - R2-D2!" },
        { n: "S-SH", name: "General Hux - Supreme Leader Snoke and the First Order" },
        { n: "S-SK", name: "Kylo Ren - Supreme Leader Snoke and the First Order" },
        { n: "S-SP", name: "Captain Phasma - Supreme Leader Snoke and the First Order" },
    ],
  },
  {
    id: "super-weapons",
    type: "insert",
    title: "SUPER WEAPONS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "SW-1", name: "Death Star" },
        { n: "SW-2", name: "Star Destroyer" },
        { n: "SW-3", name: "AT-AT" },
        { n: "SW-4", name: "Starkiller Base" },
        { n: "SW-5", name: "First Order Dreadnaught" },
        { n: "SW-6", name: "The Supremacy" },
        { n: "SW-7", name: "Superlaser Siege Cannon" },
    ],
  },
  {
    id: "heroes-autograph-book-card",
    type: "auto",
    title: "HEROES AUTOGRAPH BOOK CARD",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "HAB-1", name: "Harrison Ford / Carrie Fisher / Billy Dee Williams / Peter Mayhew / Kenny Baker / Anthony Daniels / Felicity Jones / Forest Whitaker / Daisy Ridley / John Boyega" },
    ],
  },
  {
    id: "autographed-vehicle-patch-cards",
    type: "auto",
    title: "AUTOGRAPHED VEHICLE PATCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "black", name: "Black", print_run: null, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: null, color: "#f0c040" },
      ],
    cards: [
        { n: "MPA-AD", name: "Anthony Daniels as C-3PO" },
        { n: "MPA-BH", name: "Brian Herring as BB-8" },
        { n: "MPA-BM", name: "Ben Mendelsohn as Director Krennic" },
        { n: "MPA-DBB", name: "Dee Bradley Baker as Kassius Konstantine" },
        { n: "MPA-FJ", name: "Felicity Jones as Jyn Erso" },
        { n: "MPA-FPJ", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "MPA-GMT", name: "Guy Henry as Voice of Grand Moff Tarkin" },
        { n: "MPA-GO", name: "Genevieve O'Reilly as Mon Mothma" },
        { n: "MPA-HC", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "MPA-HQ", name: "Hugh Quarshie as Captain Panaka" },
        { n: "MPA-IM", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "MPA-JB", name: "John Boyega as Finn" },
        { n: "MPA-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "MPA-MEM", name: "Mary Elizabeth McGlynn as Governor Arihnda Pryce" },
        { n: "MPA-MQ", name: "Mike Quinn as Nien Nunb" },
        { n: "MPA-RA", name: "Riz Ahmed as Bodhi Rook" },
        { n: "MPA-SB", name: "Steve Blum as Zeb Orrelios" },
        { n: "MPA-TG", name: "Taylor Gray as Ezra Bridger" },
        { n: "MPA-TS", name: "Tiya Sircar as Sabine Wren" },
        { n: "MPA-VM", name: "Vanessa Marshall as Hera Syndulla" },
    ],
  },
  {
    id: "dual-autograph-cards",
    type: "auto",
    title: "DUAL AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    // Printed card-back codes per nslists.com/swmast18.htm. DA-JM (Jones / Mendelsohn) is
    // CK-assigned: no source shows a printed code for that card.
    cards: [
        { n: "DA-RB", name: "Daisy Ridley / John Boyega as Rey / Finn" },
        { n: "DA-JM", name: "Felicity Jones / Ben Mendelsohn as Jyn Erso / Director Krennic" },
        { n: "DA-CP", name: "Hayden Christensen / Ray Park as Anakin Skywalker / Darth Maul" },
        { n: "DA-BS", name: "John Boyega / Joonas Suotamo as Finn / Chewbacca" },
        { n: "DA-MH", name: "Ben Mendelsohn / Guy Henry as Director Krennic / voice of Grand Moff Tarkin" },
        { n: "DA-AT", name: "Riz Ahmed / Alan Tudyk as Bodhi Rook / K-2SO" },
        { n: "DA-PW", name: "Ray Park / Matthew Wood as Darth Maul / General Grievous" },
        { n: "DA-BH", name: "John Boyega / Brian Herring as Finn / BB-8" },
        { n: "DA-MM", name: "Lars Mikkelsen / Mary Elizabeth McGlynn as Grand Admiral Thrawn / Governor Arihnda Pryce" },
        { n: "DA-BB", name: "Kenny Baker / David Barclay as R2-D2 / puppeteer for Yoda" },
        { n: "DA-BR", name: "Erik Bauersfeld / Kipsang Rotich as voice of Admiral Ackbar / voice of Nien Nunb" },
        { n: "DA-WQ", name: "Billy Dee Williams / Mike Quinn as Lando Calrissian / Nien Nunb" },
        { n: "DA-BO", name: "Caroline Blakiston / Genevieve O'Reilly as Mon Mothma / Mon Mothma" },
        { n: "DA-LG", name: "Ken Leung / Greg Grunberg as Admiral Statura / Snap Wexley" },
        { n: "DA-CW", name: "Aidan Cook / Ian Whyte as Benthic Two Tubes / Moroff" },
        { n: "DA-TF", name: "James Arnold Taylor / Nika Futterman as Obi-Wan Kenobi / Asajj Ventress" },
        { n: "DA-GA", name: "Sarah Michelle Gellar / Philip Anthony-Rodriguez as Seventh Sister / Fifth Brother" },
        { n: "DA-WS", name: "Sam Witwer / Stephen Stanton as Darth Maul / Obi-Wan Kenobi" },
        { n: "DA-GM", name: "George Takei / Matt Lanter as Lok Durd / Anakin Skywalker" },
        { n: "DA-SD", name: "Meredith Salenger / Olivia D'Abo as Barriss Offee / Luminara Unduli" },
    ],
  },
  {
    id: "quad-autograph-book-cards",
    type: "auto",
    title: "QUAD AUTOGRAPH BOOK CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWQ-1", name: "Harrison Ford / Carrie Fisher / Billy Dee Williams / Peter Mayhew" },
        { n: "MWQ-2", name: "Daisy Ridley / Adam Driver / John Boyega / Gwendoline Christie" },
        { n: "MWQ-3", name: "Felicity Jones / Donnie Yen / Riz Ahmed / Alan Tudyk" },
        { n: "MWQ-4", name: "Carrie Fisher / Felicity Jones / Daisy Ridley / Laura Dern" },
    ],
  },
  {
    id: "triple-autograph-cards",
    type: "auto",
    title: "TRIPLE AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    // Printed codes per nslists.com/swmast18.htm (TCDB lists these as NNO). TA-SDR
    // (Serkis / Driver / Ridley) is CK-assigned: no source shows a printed code.
    cards: [
        { n: "TA-SDR", name: "Andy Serkis / Adam Driver / Daisy Ridley as Supreme Leader Snoke / Kylo Ren / Rey" },
        { n: "TA-RBD", name: "Daisy Ridley / John Boyega / Laura Dern as Rey / Finn / Vice Admiral Amilyn Holdo" },
        { n: "TA-JMW", name: "Felicity Jones / Ben Mendelsohn / Forest Whitaker as Jyn Erso / Director Krennic / Saw Gerrera" },
        { n: "TA-WMD", name: "Billy Dee Williams / Peter Mayhew / Anthony Daniels as Lando Calrissian / Chewbacca / C-3PO" },
        { n: "TA-CML", name: "Hayden Christensen / Temuera Morrison / Daniel Logan as Anakin Skywalker / Jango Fett / Boba Fett" },
        { n: "TA-VDC", name: "Jimmy Vee / Anthony Daniels / Dave Chapman as R2-D2 / C-3PO / BB-8" },
        { n: "TA-LGR", name: "Ken Leung / Greg Grunberg / Tim Rose as Admiral Statura / Snap Wexley / Admiral Ackbar" },
        { n: "TA-IES", name: "Ashley Eckstein / Meredith Salenger / Nika Futterman as Ahsoka Tano / Barriss Offee / Asajj Ventress" },
        { n: "TA-BPG", name: "Tom Baker / Freddie Prinze Jr. / Taylor Gray as Bendu / Kanan Jarrus / Ezra Bridger" },
        { n: "TA-TLE", name: "James Arnold Taylor / Matt Lanter / Ashley Eckstein as Obi-Wan Kenobi / Anakin Skywalker / Ahsoka Tano" },
    ],
  },
  {
    id: "pen-relic-autographs",
    type: "auto",
    title: "PEN RELIC AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    // PR- codes per nslists.com/swmast18.htm, which has them for only 12 of 40 cards; the
    // codes mix actor and character initials (PR-BD vs PR-LC), so the PRA-n placeholders
    // stay until each printed code is sourced.
    cards: [
        { n: "PRA-1", name: "Harrison Ford as Han Solo" },
        { n: "PRA-2", name: "Samuel L. Jackson as Mace Windu" },
        { n: "PR-DR", name: "Daisy Ridley as Rey" },
        { n: "PRA-4", name: "Adam Driver as Kylo Ren" },
        { n: "PR-IM", name: "Ian McDiarmid as Supreme Chancellor Palpatine" },
        { n: "PRA-6", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "PRA-7", name: "Ray Park as Darth Maul" },
        { n: "PR-LC", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "PR-LD", name: "Laura Dern as Vice Admiral Amilyn Holdo" },
        { n: "PR-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "PRA-11", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "PRA-12", name: "Crystal Clarke as Ensign Pamich Nerro Goode" },
        { n: "PRA-13", name: "Simon Williamson as puppeteer for Max Rebo" },
        { n: "PR-DC", name: "Dave Chapman as puppeteer for SE-2 Worker Droid" },
        { n: "PRA-15", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "PRA-16", name: "Forest Whitaker as Saw Gerrera" },
        { n: "PRA-17", name: "Alan Tudyk as K-2SO" },
        { n: "PRA-18", name: "Guy Henry as voice of Grand Moff Tarkin" },
        { n: "PRA-19", name: "Ben Mendelsohn as Director Krennic" },
        { n: "PR-BD", name: "Ben Daniels as General Merrick" },
        { n: "PRA-21", name: "Jeremy Bulloch as Boba Fett" },
        { n: "PRA-22", name: "Clive Revill as voice of The Emperor" },
        { n: "PRA-23", name: "Brian Herring as puppeteer for BB-8" },
        { n: "PR-KL", name: "Ken Leung as Admiral Statura" },
        { n: "PR-JV", name: "Jimmy Vee as R2-D2" },
        { n: "PR-CCS", name: "Cavin Cornwall as Sidon Ithano" },
        { n: "PRA-27", name: "Paul Kasey as C'ai Threnalli" },
        { n: "PR-CB", name: "Caroline Blakiston as Mon Mothma" },
        { n: "PRA-29", name: "Tom Wilton as Ponda Baba" },
        { n: "PRA-30", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "PRA-31", name: "David Barclay as puppeteer for Yoda" },
        { n: "PRA-32", name: "Andrew Jack as General Ematt" },
        { n: "PRA-33", name: "Matt Lanter as Anakin Skywalker" },
        { n: "PRA-34", name: "Sam Witwer as Darth Maul" },
        { n: "PR-JSL", name: "Jason Spisak as Lux Bonteri" },
        { n: "PRA-36", name: "Denis Lawson as Wedge Antilles" },
        { n: "PRA-37", name: "Howie Weed as The Wampa" },
        { n: "PRA-38", name: "Nathalie Cuzner as PZ-4CO" },
        { n: "PRA-39", name: "Mads Mikkelsen as Galen Erso" },
        { n: "PRA-40", name: "Andrew Kishino as Saw Gerrera" },
    ],
  },
  {
    id: "villains-autograph-book-card",
    type: "auto",
    title: "VILLAINS AUTOGRAPH BOOK CARD",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "VAB-1", name: "Ian McDiarmid / Ray Park / Matt Wood / Jeremy Bulloch / Temuera Morrison / Guy Henry / Ben Mendelsohn / Andy Serkis / Adam Driver / Gwendoline Christie" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Jeff Abar" },
        { n: "SK-2", name: "Ben AbuSaada" },
        { n: "SK-3", name: "Jason Adams" },
        { n: "SK-4", name: "Marlo Agunos" },
        { n: "SK-5", name: "Jennifer Allyn" },
        { n: "SK-6", name: "Thomas Amici" },
        { n: "SK-7", name: "Kallan Archer" },
        { n: "SK-8", name: "Andrew Arensberg" },
        { n: "SK-9", name: "Colin Arthurs" },
        { n: "SK-10", name: "Laura Atkinson" },
        { n: "SK-11", name: "Angel Aviles" },
        { n: "SK-12", name: "Adam Beck" },
        { n: "SK-13", name: "Angelina Benedetti" },
        { n: "SK-14", name: "Tina Berardi" },
        { n: "SK-15", name: "Dan Bergren" },
        { n: "SK-16", name: "Josh Bommer" },
        { n: "SK-17", name: "John Bruce" },
        { n: "SK-18", name: "Carlos Cabaleiro" },
        { n: "SK-19", name: "Neil Camera" },
        { n: "SK-20", name: "Patricio Carrasco" },
        { n: "SK-21", name: "Justin Castaneda" },
        { n: "SK-22", name: "Başak Çetinkaya" },
        { n: "SK-23", name: "Kevin Cleveland" },
        { n: "SK-24", name: "Sebastian Cortez" },
        { n: "SK-25", name: "Jamie Cosley" },
        { n: "SK-26", name: "Carolyn Craggs" },
        { n: "SK-27", name: "Kaela Croft" },
        { n: "SK-28", name: "Ronnie Crowther" },
        { n: "SK-29", name: "Dan Curto" },
        { n: "SK-30", name: "Ted Dastick Jr." },
        { n: "SK-31", name: "Jason Davies" },
        { n: "SK-32", name: "John DiBiase" },
        { n: "SK-33", name: "Garrett Dix" },
        { n: "SK-34", name: "Louise Draper" },
        { n: "SK-35", name: "Dean Drummond" },
        { n: "SK-36", name: "Marcia Dye" },
        { n: "SK-37", name: "Gabe Farber" },
        { n: "SK-38", name: "Keith Farnum" },
        { n: "SK-39", name: "Brett Farr" },
        { n: "SK-40", name: "Andrew Fernandes" },
        { n: "SK-41", name: "Rees Finlay" },
        { n: "SK-42", name: "Ryan Finley" },
        { n: "SK-43", name: "Andrew Fry" },
        { n: "SK-44", name: "Corey Galal" },
        { n: "SK-45", name: "Jude Gallagher" },
        { n: "SK-46", name: "Gerard Garcia Jr." },
        { n: "SK-47", name: "Dave Gaskin" },
        { n: "SK-48", name: "Mick and Matt Glebe" },
        { n: "SK-49", name: "Sammy Gomez" },
        { n: "SK-50", name: "Dan Gorman" },
        { n: "SK-51", name: "Allen Grimes" },
        { n: "SK-52", name: "Ingrid Hardy" },
        { n: "SK-53", name: "Phil Hassewer" },
        { n: "SK-54", name: "Robert Hendrickson" },
        { n: "SK-55", name: "Rich Hennemann" },
        { n: "SK-56", name: "Jessica Hickman" },
        { n: "SK-57", name: "Kyle Hickman" },
        { n: "SK-58", name: "Matthew Hirons" },
        { n: "SK-59", name: "Mike James" },
        { n: "SK-60", name: "Brad Hudson" },
        { n: "SK-61", name: "Lee Hunt" },
        { n: "SK-62", name: "Alex Iniguez" },
        { n: "SK-63", name: "Darren James" },
        { n: "SK-64", name: "Mohammad Jilani" },
        { n: "SK-65", name: "George Joseph" },
        { n: "SK-66", name: "Andrew Joynes" },
        { n: "SK-67", name: "Nick Justus" },
        { n: "SK-68", name: "Frank Kadar" },
        { n: "SK-69", name: "Nathan Kennett" },
        { n: "SK-70", name: "Glen Kertes" },
        { n: "SK-71", name: "Caleb King" },
        { n: "SK-72", name: "Matt Langford" },
        { n: "SK-73", name: "Aaron Laurich" },
        { n: "SK-74", name: "Eric Lehtonen" },
        { n: "SK-75", name: "Matthew Lopez" },
        { n: "SK-76", name: "Ian MacDougall" },
        { n: "SK-77", name: "Jeff Mallinson" },
        { n: "SK-78", name: "Jay Manchand" },
        { n: "SK-79", name: "Laura Martin" },
        { n: "SK-80", name: "Michael Mastermaker" },
        { n: "SK-81", name: "Jon McKenzie" },
        { n: "SK-82", name: "Jim Mehsling" },
        { n: "SK-83", name: "Michael Mettlen" },
        { n: "SK-84", name: "Jason Miller" },
        { n: "SK-85", name: "Alex Mines" },
        { n: "SK-86", name: "Greg Mitchell" },
        { n: "SK-87", name: "Solly Mohamed" },
        { n: "SK-88", name: "Rich Molinelli" },
        { n: "SK-89", name: "Logan Monette" },
        { n: "SK-90", name: "Victor Moreno" },
        { n: "SK-91", name: "Eric Muller" },
        { n: "SK-92", name: "Ryan Olsen" },
        { n: "SK-93", name: "Jim O'Riley" },
        { n: "SK-94", name: "Marsha Parkins" },
        { n: "SK-95", name: "Darrin Pepe" },
        { n: "SK-96", name: "John Pleak" },
        { n: "SK-97", name: "Glenn Porzig" },
        { n: "SK-98", name: "Brendan Purchase" },
        { n: "SK-99", name: "Jason Queen" },
        { n: "SK-100", name: "Chris Quinn" },
        { n: "SK-101", name: "Brent Ragland" },
        { n: "SK-102", name: "Maggie Ransom" },
        { n: "SK-103", name: "Michelle Rayner" },
        { n: "SK-104", name: "Jamie Richards" },
        { n: "SK-105", name: "Tony Riley" },
        { n: "SK-106", name: "Rodney Roberts" },
        { n: "SK-107", name: "Stephanie Rosales" },
        { n: "SK-108", name: "Juan Rosales" },
        { n: "SK-109", name: "Jay Salce" },
        { n: "SK-110", name: "Omar Salinas" },
        { n: "SK-111", name: "Glenn Savage" },
        { n: "SK-112", name: "Brent Scotchmer" },
        { n: "SK-113", name: "Richard Serrao" },
        { n: "SK-114", name: "Mayumi Seto" },
        { n: "SK-115", name: "Anil Sharma" },
        { n: "SK-116", name: "Rebecca Sharp" },
        { n: "SK-117", name: "Brendan Shaw" },
        { n: "SK-118", name: "Ward Silverman" },
        { n: "SK-119", name: "Shaow Siong" },
        { n: "SK-120", name: "Todd Aaron Smith" },
        { n: "SK-121", name: "Doug Snodgrass" },
        { n: "SK-122", name: "Jason Sobol" },
        { n: "SK-123", name: "Matt Stewart" },
        { n: "SK-124", name: "Matthew Sutton" },
        { n: "SK-125", name: "Dan Tearle" },
        { n: "SK-126", name: "Rob Teranishi" },
        { n: "SK-127", name: "Phillip Trujillo" },
        { n: "SK-128", name: "Huy Truong" },
        { n: "SK-129", name: "Nikki Valenzuela" },
        { n: "SK-130", name: "Jose Ventura" },
        { n: "SK-131", name: "Chris West" },
        { n: "SK-132", name: "Trent Westbrook" },
        { n: "SK-133", name: "Gavin Williams" },
        { n: "SK-134", name: "Adam Worton" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
